module.exports = __webpack_public_path__ + "static/logo-bf96f6f815f732f17a50332619ec1240.svg";